export function formatErrorMessage(value: unknown): string {
    if (typeof value === 'string') return value
    if (Array.isArray(value)) return value.map(formatErrorMessage).filter(Boolean).join(', ')
    if (value && typeof value === 'object') {
        const error = value as Record<string, unknown>
        for (const key of ['message', 'error', 'full_messages']) {
            if (error[key]) return formatErrorMessage(error[key])
        }
        if (Array.isArray(error.errors)) return formatErrorMessage(error.errors)
        if (error.errors && typeof error.errors === 'object') {
            return Object.entries(error.errors).map(([field, detail]) =>
                `${field.replace(/_/g, ' ')} ${formatErrorMessage(detail)}`.trim()
            ).join(', ')
        }
    }
    return 'An unexpected error occurred. Please try again.'
}
